import { AxiosInstance } from "axios";
import axios from "./axios";

type BatchReportQuery = { farmIds: number[]; areaIds: number[]; batchIds: number[] };

/** Backend array parameters use repeated keys; consume every page without changing table shape. */
export async function getBatchCategories(query: BatchReportQuery, signal?: AbortSignal, client: Pick<AxiosInstance, "get"> = axios): Promise<IBatchCategory> {
  const content: IBatchCategory["content"] = [];
  let page = 0;
  const size = 999;
  let first: IBatchCategory | undefined;
  while (true) {
    const params = new URLSearchParams();
    (Object.keys(query) as (keyof BatchReportQuery)[]).forEach(key => query[key].forEach(id => params.append(key, String(id))));
    params.set("page", String(page));
    params.set("size", String(size));
    const { data } = await client.get<IBatchCategory & { last?: boolean; totalPages?: number }>(`/batches/categories?${params}`, { signal });
    first = first ?? data;
    const rows = data.content ?? [];
    content.push(...rows);
    const totalPages = data.totalPages ?? data.total_pages;
    if (!rows.length || data.last === true || (totalPages != null && page + 1 >= totalPages) ||
      (data.last == null && totalPages == null && rows.length < size)) break;
    page++;
  }
  content.sort((a, b) => `${a.farm_initials}-${a.area_initials}-${a.initials}`.localeCompare(`${b.farm_initials}-${b.area_initials}-${b.initials}`, undefined, { sensitivity: "base" }));
  return { ...first!, content };
}
